







































  import { Component, Vue, Prop } from 'vue-property-decorator'

  @Component
  export default class ConfirmModal extends Vue {
	@Prop({ type: Boolean, required: true }) isActive!: boolean;

	closeModal() {
		this.$emit('close')
	}

	}
